/* Free Custom Preview build: header-navigation-fix-v4 — 2026-08-19 */
(() => {
  const syncPreviewNavigation = () => {
    const activeTheme = window.Shopify?.theme;
    const isPreviewTheme = activeTheme?.id && activeTheme.role !== 'main';

    if (!isPreviewTheme) return;

    document.querySelectorAll('#header-component a[href]').forEach((link) => {
      const rawHref = link.getAttribute('href');
      if (!rawHref || rawHref.startsWith('#')) return;

      const url = new URL(rawHref, window.location.origin);
      if (url.origin !== window.location.origin) return;

      url.searchParams.set('preview_theme_id', String(activeTheme.id));
      link.href = `${url.pathname}${url.search}${url.hash}`;
    });
  };

  const syncSearchUi = () => {
    document.querySelectorAll('.search-modal__content .search-input').forEach((input) => {
      input.placeholder = 'Search for...';
    });
  };

  syncSearchUi();
  syncPreviewNavigation();
  window.addEventListener('DOMContentLoaded', () => {
    syncSearchUi();
    syncPreviewNavigation();
  }, { once: true });
  window.setTimeout(syncSearchUi, 600);
  window.setTimeout(syncPreviewNavigation, 600);
  document.addEventListener('shopify:section:load', () => {
    syncSearchUi();
    syncPreviewNavigation();
  });

  document.addEventListener('pointerover', (event) => {
    const menu = event.target.closest('.fc-shop-menu');
    if (!menu || menu.contains(event.relatedTarget)) return;
    menu.querySelector('.fc-shop-menu__details')?.setAttribute('open', '');
  });

  document.addEventListener('pointerout', (event) => {
    const menu = event.target.closest('.fc-shop-menu');
    if (!menu || menu.contains(event.relatedTarget)) return;
    menu.querySelector('.fc-shop-menu__details')?.removeAttribute('open');
  });

  document.addEventListener('toggle', (event) => {
    const menu = event.target.closest?.('.fc-localization-menu');
    if (!menu?.open) return;
    menu.parentElement?.querySelectorAll('.fc-localization-menu[open]').forEach((sibling) => {
      if (sibling !== menu) sibling.removeAttribute('open');
    });
  }, true);

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-fc-track-tab]');
    if (!tab) return;

    const tracking = tab.closest('[data-fc-tracking]');
    if (!tracking) return;

    const selected = tab.dataset.fcTrackTab;
    tracking.querySelectorAll('[data-fc-track-tab]').forEach((button) => {
      const active = button === tab;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', String(active));
    });
    tracking.querySelectorAll('[data-fc-track-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.fcTrackPanel !== selected;
    });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-fc-tracking-form]');
    if (!form || form.dataset.connected === 'true') return;

    event.preventDefault();
    const message = form.querySelector('[data-fc-tracking-message]');
    if (message) {
      message.hidden = false;
      message.focus?.();
    }
  });
})();
